// 存储 token 的 key
const TokenKey = 'Medical-Token'

// 存储 refresh token 的 key
const RefreshTokenKey = 'Medical-Refresh-Token'

// 存储用户信息的 key
const UserKey = 'Medical-User'

// 存储角色信息的 key
const RoleKey = 'Medical-Role'

// 存储权限信息的 key
const PermissionKey = 'Medical-Permission'

// 存储菜单信息的 key
const MenuKey = 'Medical-Menu'

/**
 * 获取 token
 * @returns {string} token
 */
export function getToken() {
  return localStorage.getItem(TokenKey)
}

/**
 * 设置 token
 * @param {string} token token值
 */
export function setToken(token) {
  localStorage.setItem(TokenKey, token)
}

/**
 * 移除 token
 */
export function removeToken() {
  localStorage.removeItem(TokenKey)
}

/**
 * 获取 refresh token
 * @returns {string} refresh token
 */
export function getRefreshToken() {
  return localStorage.getItem(RefreshTokenKey)
}

/**
 * 设置 refresh token
 * @param {string} token refresh token值
 */
export function setRefreshToken(token) {
  localStorage.setItem(RefreshTokenKey, token)
}

/**
 * 移除 refresh token
 */
export function removeRefreshToken() {
  localStorage.removeItem(RefreshTokenKey)
}

/**
 * 获取用户信息
 * @returns {Object} 用户信息对象
 */
export function getUser() {
  const userStr = localStorage.getItem(UserKey)
  try {
    return userStr ? JSON.parse(userStr) : null
  } catch (error) {
    console.error('获取用户信息失败:', error)
    return null
  }
}

/**
 * 设置用户信息
 * @param {Object} user 用户信息对象
 */
export function setUser(user) {
  localStorage.setItem(UserKey, JSON.stringify(user))
}

/**
 * 移除用户信息
 */
export function removeUser() {
  localStorage.removeItem(UserKey)
}

/**
 * 获取角色信息
 * @returns {Array} 角色数组
 */
export function getRoles() {
  const rolesStr = localStorage.getItem(RoleKey)
  try {
    return rolesStr ? JSON.parse(rolesStr) : []
  } catch (error) {
    console.error('获取角色信息失败:', error)
    return []
  }
}

/**
 * 设置角色信息
 * @param {Array} roles 角色数组
 */
export function setRoles(roles) {
  localStorage.setItem(RoleKey, JSON.stringify(roles))
}

/**
 * 移除角色信息
 */
export function removeRoles() {
  localStorage.removeItem(RoleKey)
}

/**
 * 获取权限信息
 * @returns {Array} 权限数组
 */
export function getPermissions() {
  const permissionsStr = localStorage.getItem(PermissionKey)
  try {
    return permissionsStr ? JSON.parse(permissionsStr) : []
  } catch (error) {
    console.error('获取权限信息失败:', error)
    return []
  }
}

/**
 * 设置权限信息
 * @param {Array} permissions 权限数组
 */
export function setPermissions(permissions) {
  localStorage.setItem(PermissionKey, JSON.stringify(permissions))
}

/**
 * 移除权限信息
 */
export function removePermissions() {
  localStorage.removeItem(PermissionKey)
}

/**
 * 获取菜单信息
 * @returns {Array} 菜单数组
 */
export function getMenus() {
  const menusStr = localStorage.getItem(MenuKey)
  try {
    return menusStr ? JSON.parse(menusStr) : []
  } catch (error) {
    console.error('获取菜单信息失败:', error)
    return []
  }
}

/**
 * 设置菜单信息
 * @param {Array} menus 菜单数组
 */
export function setMenus(menus) {
  localStorage.setItem(MenuKey, JSON.stringify(menus))
}

/**
 * 移除菜单信息
 */
export function removeMenus() {
  localStorage.removeItem(MenuKey)
}

/**
 * 清空所有认证信息
 */
export function clearAuth() {
  removeToken()
  removeRefreshToken()
  removeUser()
  removeRoles()
  removePermissions()
  removeMenus()
}

/**
 * 检查是否已登录
 * @returns {boolean} 是否已登录
 */
export function isAuthenticated() {
  const token = getToken()
  const user = getUser()
  return !!(token && user && user.id)
}

/**
 * 检查是否拥有权限
 * @param {Array} neededPermissions 需要的权限数组
 * @returns {boolean} 是否拥有权限
 */
export function hasPermission(neededPermissions = []) {
  if (!neededPermissions.length) {
    return true
  }
  
  const userPermissions = getPermissions()
  return neededPermissions.some(permission => userPermissions.includes(permission))
}

/**
 * 检查是否拥有角色
 * @param {Array} neededRoles 需要的角色数组
 * @returns {boolean} 是否拥有角色
 */
export function hasRole(neededRoles = []) {
  if (!neededRoles.length) {
    return true
  }
  
  const userRoles = getRoles()
  return neededRoles.some(role => userRoles.includes(role))
}

/**
 * 设置token过期时间
 * @param {number} expiresIn 过期时间（秒）
 */
export function setTokenExpires(expiresIn) {
  const expiresAt = Date.now() + expiresIn * 1000
  localStorage.setItem('tokenExpiresAt', expiresAt.toString())
}

/**
 * 检查token是否已过期
 * @returns {boolean} 是否已过期
 */
export function isTokenExpired() {
  const expiresAt = localStorage.getItem('tokenExpiresAt')
  if (!expiresAt) {
    return false
  }
  
  return Date.now() > parseInt(expiresAt, 10)
}